/** Set by the native Mac host before the web application starts. */
declare global {
  interface Window {
    __efbNativeMac?: boolean;
  }
}

export function keyboardOptionsForHost(nativeMac: boolean) {
  return nativeMac ? { scrollAssist: false, scrollPadding: false, keyboardHeight: 0 } : {};
}
